import { Fragment } from 'react';
import CategoryDataPreview from '../components/ui/category-data-preview-panel.js';

import ExportToExcel from '../components/ui/export-to-excel.js';
import { Alert } from '@mui/material';
import PageSkeleton from '../components/ui/pageskeleton.js';

import { useContext } from 'react';
import UserProfileContext from '../context/userprofilecontext.js';
import {useGetCaseCategoriesWithDRFAAndUsage} from '../api/categories.js';
import CurrentCaseRequired from "../components/ui/current-case-required.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";

function ViewCategoriesView(props) {


    const caseCategoryResult = useGetCaseCategoriesWithDRFAAndUsage();
    const caseCategories = caseCategoryResult.data;

    const userProfileContext = useContext(UserProfileContext);
    const userProfile = userProfileContext.userProfile


    const orgName = userProfile?.currentOrg?.orgName
    const caseName = userProfile?.currentCase?.caseName

    if (!caseCategories) {
        return (
            <PageSkeleton/>
        );
    }


    return (
        <Fragment>
            <ExportToExcel data={caseCategories} fileName={orgName + " - " + caseName + " Categories"} sheetName={"Case Categories"} />
            {caseCategories.length > 0 &&
                <CategoryDataPreview data={caseCategories} columnNames={Object.keys(caseCategories[0])} />
            }{caseCategories.length === 0 &&
                <Alert severity="info">No Data Found</Alert>
            }

        </Fragment>
    );
}

export default function ViewCategories(props) {
    return (
        <CaseDatabaseCheck>
        <CurrentCaseRequired>
            <ViewCategoriesView  />
        </CurrentCaseRequired>
        </CaseDatabaseCheck>
    );
}